<template lang="html">
<van-col v-if="showPrice" span="">
  <template v-if="purchased">
    <span class="purchased">
      <!-- 已购({{redeem_status}} | {{voucherId}}) -->
      已购
    </span>
  </template>
  <template v-else>
    <span class="price">{{price}}</span>
    <span
      v-if="priceOrigin"
      class="price-origin"
    >{{priceOrigin}}</span>
    <template v-if="redeem_status" class="redeem">
      <span v-if="redeem_status=='redeemed'" class="redeem">
        <van-tag round color="#ccc" text-color="#333">已兑换</van-tag>
      </span>
      <span v-if="redeem_status=='available'" class="redeem">
        <van-tag round type="success" v-on:click.stop="redeem">兑换</van-tag>
      </span>
    </template>
  </template>
</van-col>
</template>

<script>
import { Col } from 'vant'
import { Toast } from 'vant'
import Vue from 'vue'
Vue.use(Toast)
Vue.use(Col)
export default {
  name: "priceTag",
  data () {
    return {
      purchased: false,
      redeem_status: ''
    }
  },
  props: {
    episodeId: {
      type: Number
    },
    showPrice: {
      type: Boolean
    },
    price: {
      type: String
    },
    priceOrigin: {
      type: String
    },
    voucherId: {
      type: Number,
      default: null
    }
  },
  watch: {
    // episodeId: function (newVal, oldVal) {
    //   let that = this
    //   if (newVal != oldVal) {
    //     let params = {
    //       applabel: 'program',
    //       classname: 'episode',
    //       objectid: newVal
    //     }
    //     that.$api.productitem.purchase_status(params).then(res => {
    //       if (res.data.purchased.purchased) {
    //         that.purchased = true
    //       }
    //     })
    //   }
    // }
  },
  methods: {
    redeem: function () {
      Toast.loading({
        message: '正在兑换...',
        forbidClick: true,
        duration: 0
      })
      let that = this
      window.console.log("开始兑换")
      window.console.log("episodeId:", this.episodeId)
      window.console.log("voucherId:", this.voucherId)
      let params = { episode: this.episodeId }
      this.$api.voucher.update(this.voucherId, params).then(res => {
        window.console.log("更新了兑换券")
        window.console.log(res)
        // 发送消息
        that.$emit('voucher-update-success')
        Toast.clear()
        Toast.success({
          message: '已兑换',
          forbidClick: false,
          duration: 2500
        })
      })
    }
  },
  mounted () {
    let that = this
    let params = {
      applabel: 'program',
      classname: 'episode',
      objectid: that.episodeId,
      voucherid: that.voucherId
    }
    that.$api.productitem.purchase_status(params).then(res => {
      window.console.log("已经获得购买状态:", res)
      // if (res.data.purchased.purchased) {
      //   that.purchased = true
      //   that.redeem_status = res.data.redeem_status
      // }
      that.purchased = res.data.purchased.purchased
      that.redeem_status = res.data.purchased.redeem_status
    })
  },
}
</script>

<style lang="css" scoped>
.price {
  color: #e9192d
}
.price-origin {
  margin-left: 5px;
  text-decoration: line-through;
}
.redeem {
  margin-left: 5px;
}
</style>
